module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 640 480\" version=\"1\"><g fill-rule=\"evenodd\"><path fill=\"#fff\" d=\"M640 480H0V0h640z\"/><path stroke-width=\"1pt\" fill=\"#dc143c\" d=\"M640 480H0V240h640z\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/flag/pl.svg
// module id = 55
// module chunks = 0